import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Hero } from '../models/hero';
import { CardService } from '../services/card.service';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@Component({
    template: require('./custom-hero-edit.component.html'),
    selector: 'custom-hero-edit'
})
export class CustomHeroEditComponent {
    private editForm: FormGroup;

    private active: boolean = false;
    @Input() public isNew: boolean = false;

    @Input() public set model(hero: Hero) {
        this.editForm.reset(hero);

        this.active = hero !== undefined;
    }

    @Output() cancel: EventEmitter<any> = new EventEmitter();
    @Output() save: EventEmitter<Hero> = new EventEmitter();

    public teamList: Array<string> = [];
    public sexList: Array<string> = ['Male','Female','Other'];

    constructor(private service: CardService, private fb: FormBuilder) {
        this.createForm();
    }

    ngOnInit() {
        this.service.fetchTeams()
            .subscribe(data => {
                this.teamList = data;
            });
    }

    private createForm() {
        this.editForm = this.fb.group({
            LegendaryHeroId: 0,
            UserName: "",
            Name: "",
            Marvel: false,
            Encounters: false,
            Ally: false,
            Expansion: "",
            StrengthHero: false,
            TechHero: false,
            InstinctHero: false,
            CovertHero: false,
            RangedHero: false,
            Team: "",
            TeamShortName: "",
            TeamIcon: "",
            Sex: "",
            Ripley: false,
            Hulk: false,
            Wolverine: false
        });
    }

    public onSave(e): void {
        e.preventDefault();
        this.save.emit(this.editForm.value);
        this.active = false;
    }

    public onCancel(e): void {
        e.preventDefault();
        this.closeForm();
    }

    private closeForm(): void {
        this.active = false;
        this.cancel.emit();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/custom/custom-hero-edit.component.ts